<template>
    <!-- 首页 1 -->
    <div class="contents section-hero">
        <div class="container">
            <div class="container_box row">
                <h4>{{ $t("homeOne.title") }}</h4>
                <h1>{{ $t("homeOne.subtitle") }}</h1>
                <div class="container_box_img row col-lg-12">
                    <div class="col-4" v-for="(value, index) in contents" :key="index">
                        <div class="box_img_div card card-lift--hover shadow border-0">
                            <img :src="value.img" class="card-img">
                            <div class="box_img_div_text">
                                <h5>{{ value.title }}</h5>
                                <p>{{ value.subtitle }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'homeOne',
    data() {
        return {
        };
    },
    computed: {
        contents() {
            return [
                {
                    img: '/img/pay/0--76.png',
                    title: this.$t('homeOne.one1'),
                    subtitle: this.$t('homeOne.one2')
                },
                {
                    img: '/img/pay/0--77.png',
                    title: this.$t('homeOne.two1'),
                    subtitle: this.$t('homeOne.two2')
                },
                {
                    img: '/img/pay/0--78.png',
                    title: this.$t('homeOne.three1'),
                    subtitle: this.$t('homeOne.three2')
                }
            ]
        }
    },
};
</script>
<style scoped lang="scss">
.contents {
    background-image: url('/img/pay/0-_BG-3.png');
    background-position: bottom;
    background-repeat: no-repeat;
    height: var(--main-height);
    background-size: cover;
}

.container {
    height: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    .container_box {
        flex-direction: column;
        align-items: center;
        // margin-top: 60px;

        h4 {
            font-weight: 600;
        }

        h1 {
            font-weight: 700;
            color: #233dd2;

        }

        .container_box_img {
            margin-top: 50px;
            display: flex;

            .box_img_div {
                position: relative;

                // background-color: #233dd2;
                display: flex;
                justify-content: center;
                align-items: center;
                .box_img_div_text {
                    position: absolute;
                    bottom: 10%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    // left: 5%;
                    h5 {
                        color: #233dd2;
                        text-align: center;
                    }
                    p {
                        font-size: 14px;
                        text-align: center;
                    }
                }
            }
        }
    }
}

.card {
    // border-radius: 30px;
    overflow: hidden;
}
</style>
